<template>
    <div class="login-window">
        <!-- <h2>新客户快速注册</h2> -->
        <div class="content">
            <h3>欢迎注册</h3>
            <div
                class="input-wrap user-name"
                :class="{ active: params.companyName }"
                :style="companyNameBorder"
            >
                <input
                    v-model.trim="params.companyName"
                    type="text"
                    style="width:90%;"
                    maxlength="64"
                    placeholder="企业名称"
                    class="qiyeText"
                    @focus="handleFocusFS"
                    @blur="handleFocusBL"
                >
                <div :style="totascompanyName">
                    {{ title.companyName }}
                </div>
            </div>
            <div
                class="input-wrap user-name"
                :class="{ active: params.userName }"
                :style="userNameBorder"
            >
                <input
                    v-model.trim="params.userName"
                    type="text"
                    style="width:90%;"
                    placeholder="姓名"
                    class="yonghuText"
                    prefix-icon="el-icon-search"
                    @focus="handleFocusFS1"
                    @blur="handleFocusBL1"
                >
                <div :style="totasuserName">
                    {{ title.userName }}
                </div>
            </div>
            <div
                class="input-wrap user-name"
                :class="{ active: params.phone }"
                :style="phoneBorder"
            >
                <input
                    v-model.trim="params.phone"
                    type="text"
                    class="phoneText"
                    style="width:90%;"
                    maxlength="11"
                    placeholder="手机号码"
                    @focus="handleFocusFS2"
                    @blur="handleFocusBL2"
                >
                <div :style="totasphone">
                    {{ title.phone }}
                </div>
            </div>
            <div class="code-wrap flex">
                <div
                    class="input-wrap flex-1"
                    :class="{ active: params.code }"
                    :style="codeBorder"
                >
                    <input
                        v-model.trim="params.code"
                        type="text"
                        style="width:90%;"
                        maxlength="6"
                        placeholder="验证码"
                        @focus="handleFocusFS3"
                        @blur="handleFocusBL3"
                    >
                </div>
                <div style="width:125px">
                    <el-button
                        type="primary"
                        :loading="codeLoading"
                        class="btn hoverColor"
                        :disabled="disabled"
                        @click="handleMsgBtnTap"
                    >
                        {{ codeText }}
                    </el-button>
                </div>
            </div>
            <div :style="totascode">
                {{ title.code }}
            </div>
            <el-button
                v-throttle="2000"
                type="primary"
                class="login-btn hoverColor"
                :loading="loginLoading"
                @click="handleLoginClick('params')"
            >
                一键注册登录
            </el-button>
            <span
                class="goLogins"
                @click="goLogins"
            >
                已有账号？点击直接登录
            </span>
        </div>
        <nf-confirm
            :show.sync="show"
            title=""
            width="440px"
            scrollbar-h="240px"
        >
            <div
                slot="showImg"
                class="showImg"
            >
                <img src="../images/logo@2x.png">
                <span class="title_item"> 企业已实名</span>
            </div>
            <div slot="content">
                <div class="confirm_totas">
                    <img
                        src="../images/tanhao.png"
                        class="tanhao"
                    >
                    <label>
                        该企业已实名，请联系管理员
                    </label>
                </div>
                <div class="confirm_name">
                    <span>
                        {{ resetData?resetData.creatorName:'' }}：
                    </span>
                    <span>
                        {{ resetData?resetData.mobile:'' }}
                    </span>
                </div>
            </div>
            <div
                slot="footer"
                class="foot_button"
            >
                <div class="confirm_find">
                    <label>
                        联系客服找回企业：
                    </label>
                    <span>
                        400-000-0000
                    </span>
                </div>
                <el-button
                    id="handSure"
                    type="primary"
                    size="small"
                    @click="show = false"
                >
                    确 认
                </el-button>
            </div>
        </nf-confirm>

        <nf-confirm
            :show.sync="showVerificationCode"
            title="图片校验码"
            width="440px"
            scrollbar-h="90px"
            :is-cancel-btn="false"
            :handle-save-btn-click="handleSaveBtnClick"
        >
            <div slot="content">
                <div class="code-wrap flex">
                    <div
                        class="input-wrap flex-1"
                        :class="{ active: params.vercode }"
                        :style="codeBorder"
                    >
                        <input
                            v-model.trim="params.vercode"
                            type="text"
                            style="width:90%;"
                            maxlength="4"
                            placeholder="请输入图片验证码"
                            oninput="value=value.replace(/[^\da-zA-Z]/g,'');if(value.length>4) value=value.slice(0,4)"
                            @focus="handleFocusFS4"
                            @blur="handleFocusBL4"
                        >
                    </div>
                    <div style="width:125px">
                        <img
                            :src="vercodeSrc"
                            alt=""
                            @click="getVercodeSrc"
                        >
                    </div>
                </div>
            </div>
        </nf-confirm>
    </div>
</template>
<script>
import { querySmsCode, register } from '@/api/register'
import {
    valiPhone,
    valicomanyName,
    valiuserName,
    valiCode
} from '@/utils/rules'

let timer = null
export default {
    data () {
        return {
            loginLoading: false,
            // 验证码按钮loading
            codeLoading: false,
            // 获取验证码按钮内容
            codeText: '获取验证码',
            // 倒计时总秒数
            disabled: false,
            admin: {
                name: "张三三",
                mobile: 13800008888
            },
            time: 60,
            show: false,
            resetData: {},
            phone: function () {
                return `<i class="el-icon-date" />`
            },
            params: {
                phone: '',
                code: '',
                companyName: '',
                userName: ''
            },
            title: {
                phone: '',
                code: '',
                vercode: '',
                companyName: '',
                userName: ''
            },
            totasuserName: {
                fontSize: '12px',
                marginTop: '14px',
                marginLeft: '-15px',
                color: '#999',
                display: 'block'
            },
            totascompanyName: {
                fontSize: '12px',
                marginTop: '14px',
                marginLeft: '-15px',
                color: '#999',
                display: 'block'
            },
            totascode: {
                fontSize: '12px',
                color: '#999',
                marginTop: '10px',
                display: 'block'
            },
            totasvercode: {
                fontSize: '12px',
                color: '#999',
                marginTop: '10px',
                display: 'block'
            },
            totasphone: {
                fontSize: '12px',
                marginTop: '14px',
                marginLeft: '-15px',
                color: '#999',
                display: 'block'
            },
            companyNameBorder: {
                border: '1px solid #cbcbcb',
                marginBottom: '20px'
            },
            userNameBorder: {
                border: '1px solid #cbcbcb',
                marginBottom: '20px'
            },
            phoneBorder: {
                border: '1px solid #cbcbcb',
                marginBottom: '20px'
            },
            codeBorder: {
                border: '1px solid #cbcbcb',
                marginBottom: '20px'
            },
            vercodeBorder: {
                border: '1px solid #cbcbcb',
                marginBottom: '20px'
            },
            showVerificationCode: false,
            vercodeSrc: ''
        }
    },
    watch: {
        'params.code' (newValue) {
            this.params.code = String(newValue).replace(/[^0-9]/g, '')
        },
        'params.phone' (newValue) {
            this.params.phone = String(newValue).replace(/[^0-9]/g, '')
        },
        'params.autoLogin' (newValue) {
            window.localStorage.autoLogin = newValue
        }
    },
    methods: {
        goLogins () {
            setTimeout(() => {
                window.location.href = window.location.origin + '/login'
            }, 500)
        },
        handleFocusFS () {
            this.totascompanyName.color = '#999'
            this.title.companyName = '请输入您企业的名称'
            this.companyNameBorder.border = '1px solid #409EFF'
            this.companyNameBorder.marginBottom = '30px'
        },
        handleFocusBL () {
            if (this.params.companyName) {
                if (!valicomanyName(this.params.companyName)) {
                    this.totascompanyName.color = 'red'
                    this.title.companyName =
                        '企业名称只能输入2～64个汉字、字母及括号组合'
                    this.companyNameBorder.border = '1px solid red'
                    this.companyNameBorder.marginBottom = '30px'
                } else if (valicomanyName(this.params.companyName)) {
                    this.title.companyName = ''
                    this.companyNameBorder.marginBottom = '20px'
                    this.companyNameBorder.border = '1px solid #cbcbcb'
                }
            } else if (!this.params.companyName) {
                this.title.companyName = ''
                this.companyNameBorder.marginBottom = '20px'
                this.companyNameBorder.border = '1px solid #cbcbcb'
            }
        },
        handleFocusFS1 () {
            this.totasuserName.color = '#999'
            this.title.userName = '请输入您的真实姓名'
            this.userNameBorder.border = '1px solid #409EFF'
            this.userNameBorder.marginBottom = '30px'
        },
        handleFocusBL1 () {
            if (this.params.userName) {
                if (!valiuserName(this.params.userName)) {
                    this.totasuserName.color = 'red'
                    this.title.userName = '姓名只能输入2～64个汉字、字母组合'
                    this.userNameBorder.border = '1px solid red'
                    this.userNameBorder.marginBottom = '30px'
                } else if (valiuserName(this.params.userName)) {
                    this.title.userName = ''
                    this.userNameBorder.marginBottom = '20px'
                    this.userNameBorder.border = '1px solid #cbcbcb'
                }
            } else if (!this.params.userName) {
                this.title.userName = ''
                this.userNameBorder.marginBottom = '20px'
                this.userNameBorder.border = '1px solid #cbcbcb'
            }
        },
        handleFocusFS2 () {
            this.totasphone.color = '#999'
            this.title.phone = '手机号码将成为您的登录凭证'
            this.phoneBorder.border = '1px solid #409EFF'
            this.phoneBorder.marginBottom = '30px'
        },
        handleFocusBL2 () {
            if (this.params.phone) {
                if (!valiPhone(this.params.phone)) {
                    this.totasphone.color = 'red'
                    this.title.phone = '请输入正确的手机号码'
                    this.phoneBorder.border = '1px solid red'
                    this.phoneBorder.marginBottom = '30px'
                } else if (valiPhone(this.params.phone)) {
                    this.title.phone = ''
                    this.phoneBorder.marginBottom = '20px'
                    this.phoneBorder.border = '1px solid #cbcbcb'
                }
            } else if (!this.params.phone) {
                this.title.phone = ''
                this.phoneBorder.marginBottom = '20px'
                this.phoneBorder.border = '1px solid #cbcbcb'
            }
        },
        handleFocusFS3 () {
            this.totascode.color = '#999'
            this.title.code = ''
            this.codeBorder.border = '1px solid #409EFF'
            this.codeBorder.marginBottom = '30px'
            this.totascode.marginTop = '-10px'
        },
        handleFocusBL3 () {
            if (this.params.code) {
                if (!valiCode(this.params.code)) {
                    this.totascode.color = 'red'
                    this.title.code = '请输入正确的验证码'
                    this.codeBorder.border = '1px solid red'
                    this.codeBorder.marginBottom = '30px'
                    this.totascode.marginTop = '-10px'
                } else if (valiCode(this.params.code)) {
                    this.title.code = ''
                    this.codeBorder.marginBottom = '10px'
                    this.totascode.marginTop = '-10px'
                    this.codeBorder.border = '1px solid #cbcbcb'
                }
            } else if (!this.params.code) {
                this.title.code = ''
                this.codeBorder.marginBottom = '30px'
                this.codeBorder.border = '1px solid #cbcbcb'
                this.totascode.marginTop = '-10px'
            }
        },
        handleFocusFS4 () {
            this.totasvercode.color = '#999'
            this.title.vercode = ''
            this.vercodeBorder.border = '1px solid #409EFF'
            this.vercodeBorder.marginBottom = '30px'
            this.totasvercode.marginTop = '-10px'
        },
        handleFocusBL4 () {
            if (this.params.vercode.length !== 4) {
                this.title.vercode = ''
                this.vercodeBorder.marginBottom = '30px'
                this.vercodeBorder.border = '1px solid #cbcbcb'
                this.totasvercode.marginTop = '-10px'
            }
        },
        // 点击获取短信验证码
        handleSaveBtnClick () {
            this.querySmsCode()
        },
        async querySmsCode () {
            try {
                let data = await querySmsCode({
                    phoneNum: this.params.phone,
                    vcode: this.params.vercode
                })
                if (data) {
                    this.codeLoading = false
                    this.$message({
                        message: data.msg,
                        type: 'success'
                    })
                    this.params.code = data.data.code
                    this.showVerificationCode = false
                } else {
                    this.getVercodeSrc()
                    this.codeLoading = false
                    return
                }
                setTimeout(() => {
                    this.codeLoading = false
                }, 500)
            } catch (err) {
                this.$$message('获取手机验证码 失败：' + err, 'error')
                setTimeout(() => {
                    this.codeLoading = false
                }, 500)
                return
            }
            if (timer) {
                clearInterval(timer)
            }
            this.codeText = this.time + '秒后获取'
            this.disabled = true
            timer = setInterval(async () => {
                this.codeText = --this.time + '秒后获取'
                if (this.time <= 0) {
                    clearInterval(timer)
                    this.time = 60
                    this.codeText = '获取验证码'
                    this.disabled = false
                }
            }, 1000)
        },
        getVercodeSrc () {
            this.vercodeSrc = '/rest/getVerificationCode?mobile=' + this.params.phone + "&random=" + Math.random()
        },
        async handleMsgBtnTap () {
            if (this.params.phone) {
                if (!valiPhone(this.params.phone)) {
                    this.totasphone.color = 'red'
                    this.title.phone = '请输入正确的手机号码'
                    return
                } else {
                    this.showVerificationCode = true
                    this.getVercodeSrc()
                }
            } else {
                this.totasphone.color = 'red'
                this.title.phone = '请输入正确的手机号码'
                this.phoneBorder.border = '1px solid red'
                this.phoneBorder.marginBottom = '30px'
            }
        },
        async handleLoginClick () {
            if (
                valicomanyName(this.params.companyName) &&
                valiPhone(this.params.phone) &&
                valiuserName(this.params.userName) &&
                valiCode(this.params.code)
            ) {
                let res = await register({
                    administrator: this.params.userName,
                    companyName: this.params.companyName,
                    phoneNum: this.params.phone,
                    register: '',
                    smsCode: this.params.code
                })
                try {
                    this.resetData = res.data ? res.data : {}
                    if (res.code === 200) {
                        this.params = {}
                        this.loginLoading = false
                        clearInterval(timer)
                        this.time = 60
                        this.codeText = '获取验证码'
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            showClose: 'true'
                        })
                        let str = res.data.domain
                        let ipName = window.location.hostname.split('.')[0]
                        window.location.href = window.location.origin.replace(
                            ipName,
                            str
                        )
                    } else if (res.code === 201) {
                        this.show = true
                    }
                } catch (err) {
                    loginTime = setTimeout(() => {
                        this.loginLoading = false
                    }, 300)
                }
            } else {
                this.loginLoading = false
                clearInterval(timer)
                this.time = 60
                this.codeText = '获取验证码'
                if (this.params.companyName) {
                    if (!valicomanyName(this.params.companyName)) {
                        this.totascompanyName.color = 'red'
                        this.title.companyName =
                            '企业名称只能输入2～64个汉字、字母及括号组合'
                        this.companyNameBorder.border = '1px solid red'
                        this.companyNameBorder.marginBottom = '30px'
                    } else if (valicomanyName(this.params.companyName)) {
                        this.title.companyName = ''
                        this.companyNameBorder.marginBottom = '20px'
                        this.companyNameBorder.border = '1px solid #cbcbcb'
                    }
                } else if (!this.params.companyName) {
                    this.totascompanyName.color = 'red'
                    this.title.companyName =
                        '企业名称只能输入2～64个汉字、字母及括号组合'
                    this.companyNameBorder.border = '1px solid red'
                    this.companyNameBorder.marginBottom = '30px'
                }
                if (this.params.userName) {
                    if (!valiuserName(this.params.userName)) {
                        this.totasuserName.color = 'red'
                        this.title.userName =
                            '姓名只能输入2～64个汉字、字母组合'
                        this.userNameBorder.border = '1px solid red'
                        this.userNameBorder.marginBottom = '30px'
                    } else if (valiuserName(this.params.userName)) {
                        this.title.userName = ''
                        this.userNameBorder.marginBottom = '20px'
                        this.userNameBorder.border = '1px solid #cbcbcb'
                    }
                } else if (!this.params.userName) {
                    this.totasuserName.color = 'red'
                    this.title.userName = '姓名只能输入2～64个汉字、字母组合'
                    this.userNameBorder.border = '1px solid red'
                    this.userNameBorder.marginBottom = '30px'
                }
                if (this.params.phone) {
                    if (!valiPhone(this.params.phone)) {
                        this.totasphone.color = 'red'
                        this.title.phone = '请输入正确的手机号码'
                        this.phoneBorder.border = '1px solid red'
                        this.phoneBorder.marginBottom = '30px'
                    } else if (valiPhone(this.params.phone)) {
                        this.title.phone = ''
                        this.phoneBorder.marginBottom = '20px'
                        this.phoneBorder.border = '1px solid #cbcbcb'
                    }
                } else if (!this.params.phone) {
                    this.totasphone.color = 'red'
                    this.title.phone = '请输入正确的手机号码'
                    this.phoneBorder.border = '1px solid red'
                    this.phoneBorder.marginBottom = '30px'
                }
                if (this.params.code) {
                    if (!valiCode(this.params.code)) {
                        this.totascode.color = 'red'
                        this.title.code = '请输入正确的验证码'
                        this.codeBorder.border = '1px solid red'
                        this.codeBorder.marginBottom = '30px'
                        this.totascode.marginTop = '-10px'
                    } else if (valiCode(this.params.code)) {
                        this.title.code = ''
                        this.codeBorder.marginBottom = '30px'
                        this.totascode.marginTop = '-10px'
                        this.codeBorder.border = '1px solid #cbcbcb'
                    }
                } else if (!this.params.code) {
                    this.totascode.color = 'red'
                    this.title.code = '请输入正确的验证码'
                    this.codeBorder.border = '1px solid red'
                    this.codeBorder.marginBottom = '30px'
                    this.totascode.marginTop = '-10px'
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.login-window {
    width: 461px;
    height: auto;
    background: #fcfcfc;
    border-radius: 4px;
    .content {
        background: #fcfcfc;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        height: 100%;
        border-radius: 4px;
        padding: 48px 48px 0 48px;
    }
    h3 {
        margin-bottom: 38px;
        width: 260px;
        height: 37px;
        font-size: 26px;
        font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            '微软雅黑', Arial, sans-serif;
        font-weight: 400;
        font-weight: 600;
        color: rgba(11, 21, 39, 1);
        line-height: 37px;
    }
    .input-wrap {
        // border: 1px solid #cbcbcb;
        background: #fcfcfc;
        border-radius: 0px;
        height: 46px;
        width: 100%;
        padding: 10px 18px;
        box-sizing: border-box;
        &.active {
            border-color: rgba(33, 84, 189, 1);
        }
        input {
            height: 22px;
            font-size: 14px;
            font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
                '微软雅黑', Arial, sans-serif;
            font-weight: 400;
            // line-height:33px;
            color: #121c40;
            // padding-left: 20px;
        }
        input::-webkit-search-cancel-button {
            display: none;
        }
        .phoneText {
            padding: 0px 0px 8px 40px;
            background-image: url(../images/phone1.png);
            background-repeat: no-repeat;
            background-position: -5px -2px;
            background-size: 30px 30px;
        }
        .yonghuText {
            padding: 0px 0px 8px 40px;
            background-image: url(../images/yonghu1.png);
            background-repeat: no-repeat;
            background-position: -5px -4px;
            background-size: 30px 33px;
        }
        .qiyeText {
            padding: 0px 0px 8px 40px;
            background-image: url(../images/qiye.png);
            background-repeat: no-repeat;
            background-position: -5px -2px;
            background-size: 30px 32px;
        }
    }
    .login-btn {
        background: rgba(33, 84, 189, 1);
        width: 100%;
        border: 0;
        border-radius: 0;
        margin: 8px 0 8px 0;
        border-radius: 0px !important;
        padding: 15px 0px;
        font-size: 15px;
    }
    .goLogins {
        font-size: 14px;
        font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            '微软雅黑', Arial, sans-serif;
        font-weight: 400;
        color: rgba(33, 84, 189, 1);
        line-height: 60px;
        cursor: pointer;
    }
    .goLogins:hover {
        color: rgba(14, 81, 216, 0.9);
    }
    .code-wrap {
        align-items: center;
        margin-bottom: 20px;
        button {
            padding: 14px 20px;
            margin-left: 15px;
            border-radius: 0px !important;
        }
        .input-wrap {
            margin: 0 !important;
        }
        button.active {
            color: #787f95;
        }
    }
}
.hoverColor:hover {
    background: rgba(33, 84, 189, 0.95) !important;
}
.showImg {
    img {
        position: absolute;
        height: 20px;
        width: 56px;
        top: 23px;
        left: 20px;
    }
    .title_item {
        position: absolute;
        left: 90px;
        top: 22px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(32, 32, 32, 1);
        line-height: 22px;
    }
    .title_item::before {
        content: '|';
        height: 4px;
        font-weight: 100;
        color: #d8d9e1;
        margin-right: 5px;
    }
}
.tanhao {
    height: 16px;
    width: 16px;
    margin-right: 5px;
    display: inline-block;
}
.confirm_totas {
    height: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    display: flex;
    color: #181818;
    margin: 45px 0 60px 15px;
    line-height: 16px;
}
.confirm_name {
    height: 20px;
    line-height: 20px;
    display: flex;
    margin-left: 25px;
    span {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        font-size: 14px;
        letter-spacing: 0.5px;
    }
}
#handSure {
    width: 75px;
    margin-top: -5px;
    span {
        font-size: 14px;
    }
}
.el-dialog__footer {
    padding: 10px 40px 20px;
}
.foot_button {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181818;
    margin-left: 15px;
    span {
        color: #666666;
    }
}
.login-window .input-wrap input[data-v-031d122e] {
    font-size: 14px !important;
}

input::-webkit-input-placeholder {
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(187, 192, 207, 1) !important;
    cursor: text !important;
}
input::-moz-input-placeholder {
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(187, 192, 207, 1) !important;
    cursor: text !important;
}
input::-ms-input-placeholder {
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(187, 192, 207, 1) !important;
    cursor: text !important;
}
</style>
